import React from 'react';
import { CaApiSdk } from '../types';
import { CaApiSdkManager } from '../utils/ca-api-sdk-manager';

const defaultSdk: CaApiSdk = CaApiSdkManager.createSdk(null, null);

export const CaApiSdkContext = React.createContext<CaApiSdk>(defaultSdk);
